module.exports = __webpack_public_path__ + "img/sms.2ba423f7.svg";